import { TradingThemeProvider } from '@trading-ui/core';
import { PropsWithChildren } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { useLocalStorage } from 'usehooks-ts';

import ThemeCSSGenerator from '../theme-css-generator/ThemeCssGenerator';

import { STORAGE_KEYS } from '../../constants/storageKeys';

export default function StandaloneWrapper(props: PropsWithChildren) {
  const { children } = props;
  const [darkMode] = useLocalStorage(`app-${STORAGE_KEYS.DARK_MODE}`, false);

  return (
    <TradingThemeProvider darkMode={darkMode}>
      <ThemeCSSGenerator />
      <BrowserRouter>{children}</BrowserRouter>
    </TradingThemeProvider>
  );
}
